module.exports = __webpack_public_path__ + "media/images/kids9-20fd75a1ef8a55955475a932deaa3293.jpg";